


<script>
import {supabase} from "./supabaseClient"
import { fade } from 'svelte/transition';
import router from 'page'

import StandardHeader from "./StandardHeader.svelte"
import StandardFooter from "./StandardFooter.svelte"

let email;
let password;
let errorMessage = '';

// Event snippet for Sign-up conversion page In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button.
function gtag_report_conversion(url) {
  var callback = function () {
    if (typeof(url) != 'undefined') {
      window.location = url;
    }
  };
  gtag('event', 'conversion', {
      'send_to': 'AW-827582476/bzVmCP34oKMDEIzQz4oD',
      'value': 0.0,
      'currency': 'GBP',
      'event_callback': callback
  });
  return false;
}

const handleCreateAccoubnt = async () => {
  const { user, session, error } = await supabase.auth.signUp({
    email: email,
    password: password,
  })

  if (error) {
    errorMessage = error.message
    console.log(error)
    return;
  } else {
    gtag_report_conversion()
    router.redirect('/myboards')
  }

}
</script>

<div class="pageContainer">

  <StandardHeader />

  <div class="mainContentSection" style="min-width:300px">
    <div><b>Create Account</b></div>
    <form on:submit|preventDefault={handleCreateAccoubnt} id="SignUp">
      
      <div class="mb-3">
        <input placeholder="Email" bind:value={email} style="width:100%" on:input={() => errorMessage=''}   class="input input-bordered w-full" />
      </div>

      <div class="mb-3">
        <input type="password" placeholder="Password" bind:value={password} style="width:100%" on:input={() => errorMessage=''}  class="input input-bordered w-full"/> 
      </div>
      {#if errorMessage != ''}
          <div style="color:red" in:fade="{{ y: 200, duration: 1500 }}">{errorMessage}</div>
      {/if}
      <div>
        <button id="SignUp" style="float:right" type="submit"   class="btn bg-[var(--aqua)] text-white hover:opacity-90">Create Account</button> 
      </div>
    </form>
    <div style="text-align:center">Already have an account? <a href="/Login">Click here to sign in.</a></div>
  </div>

  <StandardFooter />

</div>

<style>
.pageContainer{min-height:100vh;  display: flex; flex-direction: column; }
.mainContentSection {min-height: calc(100vh - 200px);  display: flex; flex-direction: column; align-self: center; justify-content: center}
</style>
